import { render, staticRenderFns } from "./TextReadMoreCpt.vue?vue&type=template&id=5118c69e&scoped=true&"
import script from "./TextReadMoreCpt.vue?vue&type=script&lang=ts&"
export * from "./TextReadMoreCpt.vue?vue&type=script&lang=ts&"
import style0 from "./TextReadMoreCpt.vue?vue&type=style&index=0&id=5118c69e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5118c69e",
  null
  
)

export default component.exports